module.exports = __webpack_public_path__ + "img/PhoneMissedOutlined.43040c60.svg";